export const countries = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
    "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
    "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo (Congo-Brazzaville)", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czechia (Czech Republic)",
    "Denmark", "Djibouti", "Dominica", "Dominican Republic",
    "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini (fmr. 'Swaziland')", "Ethiopia",
    "Fiji", "Finland", "France",
    "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
    "Haiti", "Holy See", "Honduras", "Hungary",
    "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
    "Jamaica", "Japan", "Jordan",
    "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan",
    "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
    "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar (formerly Burma)",
    "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway",
    "Oman",
    "Pakistan", "Palau", "Palestine State", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
    "Qatar",
    "Romania", "Russia", "Rwanda",
    "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
    "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
    "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
    "Vanuatu", "Venezuela", "Vietnam",
    "Yemen",
    "Zambia", "Zimbabwe"
];

// ISO country code map for IP-based location detection
export const isoCountryCodeMap: Record<string, { name: string; phoneCode: string }> = {
    US: { name: 'United States', phoneCode: '+1' },
    CA: { name: 'Canada', phoneCode: '+1' },
    GB: { name: 'United Kingdom', phoneCode: '+44' },
    AU: { name: 'Australia', phoneCode: '+61' },
    DE: { name: 'Germany', phoneCode: '+49' },
    FR: { name: 'France', phoneCode: '+33' },
    IT: { name: 'Italy', phoneCode: '+39' },
    ES: { name: 'Spain', phoneCode: '+34' },
    NL: { name: 'Netherlands', phoneCode: '+31' },
    BE: { name: 'Belgium', phoneCode: '+32' },
    CH: { name: 'Switzerland', phoneCode: '+41' },
    AT: { name: 'Austria', phoneCode: '+43' },
    SE: { name: 'Sweden', phoneCode: '+46' },
    NO: { name: 'Norway', phoneCode: '+47' },
    DK: { name: 'Denmark', phoneCode: '+45' },
    FI: { name: 'Finland', phoneCode: '+358' },
    PL: { name: 'Poland', phoneCode: '+48' },
    PT: { name: 'Portugal', phoneCode: '+351' },
    IE: { name: 'Ireland', phoneCode: '+353' },
    GR: { name: 'Greece', phoneCode: '+30' },
    JP: { name: 'Japan', phoneCode: '+81' },
    KR: { name: 'South Korea', phoneCode: '+82' },
    CN: { name: 'China', phoneCode: '+86' },
    IN: { name: 'India', phoneCode: '+91' },
    SG: { name: 'Singapore', phoneCode: '+65' },
    HK: { name: 'Hong Kong', phoneCode: '+852' },
    PH: { name: 'Philippines', phoneCode: '+63' },
    ID: { name: 'Indonesia', phoneCode: '+62' },
    MY: { name: 'Malaysia', phoneCode: '+60' },
    TH: { name: 'Thailand', phoneCode: '+66' },
    VN: { name: 'Vietnam', phoneCode: '+84' },
    NZ: { name: 'New Zealand', phoneCode: '+64' },
    BR: { name: 'Brazil', phoneCode: '+55' },
    MX: { name: 'Mexico', phoneCode: '+52' },
    AR: { name: 'Argentina', phoneCode: '+54' },
    CL: { name: 'Chile', phoneCode: '+56' },
    CO: { name: 'Colombia', phoneCode: '+57' },
    PE: { name: 'Peru', phoneCode: '+51' },
    ZA: { name: 'South Africa', phoneCode: '+27' },
    NG: { name: 'Nigeria', phoneCode: '+234' },
    KE: { name: 'Kenya', phoneCode: '+254' },
    EG: { name: 'Egypt', phoneCode: '+20' },
    MA: { name: 'Morocco', phoneCode: '+212' },
    AE: { name: 'United Arab Emirates', phoneCode: '+971' },
    SA: { name: 'Saudi Arabia', phoneCode: '+966' },
    IL: { name: 'Israel', phoneCode: '+972' },
    TR: { name: 'Turkey', phoneCode: '+90' },
    RU: { name: 'Russia', phoneCode: '+7' },
    UA: { name: 'Ukraine', phoneCode: '+380' },
    PK: { name: 'Pakistan', phoneCode: '+92' },
    BD: { name: 'Bangladesh', phoneCode: '+880' },
};

export const phoneCountryCodes = [
    { code: "+1", country: "United States", flag: "🇺🇸" },
    { code: "+1", country: "Canada", flag: "🇨🇦" },
    { code: "+44", country: "United Kingdom", flag: "🇬🇧" },
    { code: "+61", country: "Australia", flag: "🇦🇺" },
    { code: "+49", country: "Germany", flag: "🇩🇪" },
    { code: "+33", country: "France", flag: "🇫🇷" },
    { code: "+39", country: "Italy", flag: "🇮🇹" },
    { code: "+34", country: "Spain", flag: "🇪🇸" },
    { code: "+31", country: "Netherlands", flag: "🇳🇱" },
    { code: "+32", country: "Belgium", flag: "🇧🇪" },
    { code: "+41", country: "Switzerland", flag: "🇨🇭" },
    { code: "+43", country: "Austria", flag: "🇦🇹" },
    { code: "+46", country: "Sweden", flag: "🇸🇪" },
    { code: "+47", country: "Norway", flag: "🇳🇴" },
    { code: "+45", country: "Denmark", flag: "🇩🇰" },
    { code: "+358", country: "Finland", flag: "🇫🇮" },
    { code: "+48", country: "Poland", flag: "🇵🇱" },
    { code: "+351", country: "Portugal", flag: "🇵🇹" },
    { code: "+353", country: "Ireland", flag: "🇮🇪" },
    { code: "+30", country: "Greece", flag: "🇬🇷" },
    { code: "+81", country: "Japan", flag: "🇯🇵" },
    { code: "+82", country: "South Korea", flag: "🇰🇷" },
    { code: "+86", country: "China", flag: "🇨🇳" },
    { code: "+91", country: "India", flag: "🇮🇳" },
    { code: "+65", country: "Singapore", flag: "🇸🇬" },
    { code: "+852", country: "Hong Kong", flag: "🇭🇰" },
    { code: "+63", country: "Philippines", flag: "🇵🇭" },
    { code: "+62", country: "Indonesia", flag: "🇮🇩" },
    { code: "+60", country: "Malaysia", flag: "🇲🇾" },
    { code: "+66", country: "Thailand", flag: "🇹🇭" },
    { code: "+84", country: "Vietnam", flag: "🇻🇳" },
    { code: "+64", country: "New Zealand", flag: "🇳🇿" },
    { code: "+55", country: "Brazil", flag: "🇧🇷" },
    { code: "+52", country: "Mexico", flag: "🇲🇽" },
    { code: "+54", country: "Argentina", flag: "🇦🇷" },
    { code: "+56", country: "Chile", flag: "🇨🇱" },
    { code: "+57", country: "Colombia", flag: "🇨🇴" },
    { code: "+51", country: "Peru", flag: "🇵🇪" },
    { code: "+27", country: "South Africa", flag: "🇿🇦" },
    { code: "+234", country: "Nigeria", flag: "🇳🇬" },
    { code: "+254", country: "Kenya", flag: "🇰🇪" },
    { code: "+20", country: "Egypt", flag: "🇪🇬" },
    { code: "+212", country: "Morocco", flag: "🇲🇦" },
    { code: "+971", country: "United Arab Emirates", flag: "🇦🇪" },
    { code: "+966", country: "Saudi Arabia", flag: "🇸🇦" },
    { code: "+972", country: "Israel", flag: "🇮🇱" },
    { code: "+90", country: "Turkey", flag: "🇹🇷" },
    { code: "+7", country: "Russia", flag: "🇷🇺" },
    { code: "+380", country: "Ukraine", flag: "🇺🇦" },
    { code: "+92", country: "Pakistan", flag: "🇵🇰" },
    { code: "+880", country: "Bangladesh", flag: "🇧🇩" },
];
